import whenDomReady from 'when-dom-ready';
import ViewSubscriptions from '@/views/view-subscriptions';
import ViewPromoCarousel from '@/views/view-promoCarousel';
import $ from 'jquery';

import '../../styles/pages/account.scss';
import { defineComponent } from '@/components/base';
import Recommendations from '@/components/account/recommendations';
import LoadingSpinnerComponent from '@/components/loading-spinner';
whenDomReady(() => {
  console.log('init subscription page');

  defineComponent('product-recommendations', Recommendations);
  defineComponent('loading-spinner', LoadingSpinnerComponent);

  var $accountNavLinks = $('.account-nav > .links');
  if ($accountNavLinks.length) {
    $accountNavLinks.on('click', function () {
      $accountNavLinks.toggleClass('opened');
    });
  }
  new ViewSubscriptions({ el: $('#MainContent') });
  new ViewPromoCarousel({ el: $('#account-promo-carousel') });
});
